import { render, staticRenderFns } from "./taskProgress.vue?vue&type=template&id=663e53d3&scoped=true"
import script from "./taskProgress.vue?vue&type=script&lang=js"
export * from "./taskProgress.vue?vue&type=script&lang=js"
import style0 from "./taskProgress.vue?vue&type=style&index=0&id=663e53d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e53d3",
  null
  
)

export default component.exports